import { render } from "./FormProducts.vue?vue&type=template&id=2e844d20&scoped=true"
import script from "./FormProducts.vue?vue&type=script&lang=js"
export * from "./FormProducts.vue?vue&type=script&lang=js"

import "./FormProducts.vue?vue&type=style&index=0&id=2e844d20&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e844d20"]])

export default __exports__